import React from 'react';

import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import GenericModal from '@portal/components/GenericModal/GenericModal';
import ThemedText from '@portal/components/ThemedText/ThemedText';
import { translate } from '@portal/services/i18n';
import './CardViewPasswordModal.less';

type CardViewPasswordModalProps = {
  visible: boolean;
  onClose: () => void;
  myPassword: string | null;
  showViewPasswordValue: boolean;
  onToggleVisibility: () => void;
};

const CardViewPasswordModal = ({
  visible,
  onClose,
  myPassword,
  showViewPasswordValue,
  onToggleVisibility,
}: CardViewPasswordModalProps) => {
  return (
    <GenericModal
      visible={visible}
      onClose={onClose}
      actions={[
        {
          label: translate(
            'PAGES.CARDS.MY_CARDS.DETAILS.VIEW_PASSWORD.PASSWORD.BUTTONS.CLOSE'
          ),
          onClick: onClose,
          variant: 'outlined',
        },
      ]}
      title={translate(
        'PAGES.CARDS.MY_CARDS.DETAILS.VIEW_PASSWORD.PASSWORD.TITLE'
      )}
      description={translate(
        'PAGES.CARDS.MY_CARDS.DETAILS.VIEW_PASSWORD.PASSWORD.DESCRIPTION'
      )}
    >
      <div className="card-view-password-modal__content" data-sentry-mask>
        <ThemedText className="card-view-password-modal__value">
          {showViewPasswordValue ? myPassword : '••••'}
        </ThemedText>
        <button className="transparent-button" onClick={onToggleVisibility}>
          {showViewPasswordValue ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        </button>
      </div>
    </GenericModal>
  );
};

export default CardViewPasswordModal;
